<template>
  <div>
    <el-upload
      class="avatar-uploader"
      accept=".jpg, .png"
      :action="qiniuUrl"
      :data="imageToken"
      :show-file-list="false"
      :on-success="handleCoverSuccess"
      :before-upload="beforeCoverUpload"
    >
      <img v-if="photo" :src="photo" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon" />
    </el-upload>
  </div>
</template>

<script>
import qiniuUpload from '@/assets/js/upload.js'
export default {
  name: 'UploadImg',
  props: {
    photo: String,
    name: String
  },
  data() {
    return {
      qiniuUrl: qiniuUpload.qiniuUrl,
      imageToken: {
        token: '',
        key: ''
      },
      image: ''
    }
  },
  created: function() {
    this.imgToken()
  },
  methods: {
    imgToken() {
      this.$http.imgToken().then(ret => {
        this.imageToken.token = ret.token
      })
    },
    beforeCoverUpload(file) {
      const type = file.name.split('.')[1]
      const isLt600K = (file.size / 1024) < 600
      if (type != 'jpg' && type != 'jpeg' && type != 'png') {
        this.$message({
          type: 'warning',
          message: '文件格式不正确'
        })
        return false
      }
      if (!isLt600K) {
        this.$message({
          type: 'warning',
          message: '文件应小于600K'
        })
        return false
      }
      this.imageToken.key =
        new Date().getTime() + '' + Math.ceil(Math.random() * 10000) + '.jpg'
    },
    handleCoverSuccess(ret) {
      // this.photo = qiniuUpload.imgSpace + ret.key;
      this.$emit('updateImg', qiniuUpload.imgSpace + ret.key, this.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader-icon {
  border: 1px solid $color_blue;
  border-radius: 4px;
  font-size: 28px;
  color: $color_blue;
  width: 120px;
  height: 90px;
  line-height: 90px;
  text-align: center;
  overflow: hidden;
}
.avatar {
  border: 1px solid $color_blue;
  border-radius: 4px;
  width: 120px;
  height: 90px;
  display: block;
  overflow: hidden;
}
</style>
